import { SVGProps } from 'react'

import { wrapIllustration } from '../wrap-illustration'

function SvgPayment(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={160}
      height={160}
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M13.2 48.356a4.64 4.64 0 0 1 3.281-5.682l71.702-19.212a4.64 4.64 0 0 1 5.682 3.28l12.008 44.814a4.64 4.64 0 0 1-3.281 5.682L30.891 96.45a4.64 4.64 0 0 1-5.682-3.28L13.2 48.356Z"
        fill="#78B441"
      />
      <path
        d="m95.306 32.12-1.44-5.378a4.64 4.64 0 0 0-5.683-3.28l-2.688.72-39.367 68.186 17.029-4.563 32.15-55.685ZM46.059 34.749l-2.789 4.83a4.92 4.92 0 1 0 8.523 4.92l7.71-13.352-13.444 3.602Z"
        fill="#599F40"
      />
      <path
        d="m52.287 70.544-18.821 5.043a1.392 1.392 0 1 0 .72 2.69l18.822-5.044a1.392 1.392 0 0 0-.72-2.689Z"
        fill="#00664F"
      />
      <path
        d="M53.702 71.606a1.092 1.092 0 0 0-1.338-.772l-18.821 5.043a1.092 1.092 0 0 0 .565 2.11l18.822-5.044c.582-.156.928-.755.772-1.337Zm.58-.156a1.693 1.693 0 0 1-1.197 2.073l-18.821 5.043a1.692 1.692 0 0 1-.876-3.268l18.821-5.043a1.692 1.692 0 0 1 2.073 1.195Z"
        fill="#00664F"
      />
      <path
        d="M95.546 33.016 14.882 54.63l2.882 10.755 80.664-21.613-2.882-10.756Z"
        fill="#0F172A"
      />
      <path
        d="m48.35 77.363-13.444 3.602a1.392 1.392 0 1 0 .721 2.689l13.444-3.602a1.392 1.392 0 0 0-.72-2.69Z"
        fill="#00664F"
      />
      <path
        d="M49.766 78.424a1.092 1.092 0 0 0-1.337-.772l-13.445 3.603a1.092 1.092 0 0 0 .565 2.109l13.445-3.603c.582-.156.928-.755.772-1.337Zm.579-.155a1.692 1.692 0 0 1-1.196 2.072l-13.444 3.603a1.692 1.692 0 0 1-.876-3.269l13.444-3.602a1.692 1.692 0 0 1 2.072 1.196Z"
        fill="#00664F"
      />
      <path
        d="M78.912 67.733a4.176 4.176 0 1 1 8.066-2.161 4.176 4.176 0 0 1-8.066 2.16Z"
        fill="#007A5F"
      />
      <path
        d="M84.29 66.292a4.175 4.175 0 1 1 8.065-2.162 4.175 4.175 0 0 1-8.066 2.162Z"
        fill="#599F40"
      />
    </svg>
  )
}
export default wrapIllustration(SvgPayment)
